import translation from '@tools/translations/translations';

/* eslint-disable @typescript-eslint/no-explicit-any */

export function trans(key: string, context?: Record<string, any>) {
  let result = translation().messages[key] || key;
  if (typeof context === 'object') {
    const matches = result.match(/(%([^%]|%%)*%)/g);
    if (matches) {
      matches.forEach((match: string) => {
        const prop = match.replace(/[%]+/g, '');
        if (!Object.prototype.hasOwnProperty.call(context, prop)) {
          return;
        }
        const regex = new RegExp(match, 'g');
        result = result.replace(regex, context[prop]);
      });
    }
  }
  return result;
}

export function transchoice(key: string, context?: Record<string, any>) {
  const rangePattern = /(\[|\])(\d+|Inf), ?(\d+|Inf)(\[|\])(.+)/;
  const exactPattern = /\{(\d+)\}(.*)/;

  let result = translation().messages[key] || key;
  // split choice template on delimiter `|`
  const templates = result.split('|');
  templates.forEach((t: string) => {
    const choice = parseInt(context?.count, 10);
    // for each choice pattern, determine the type: exact or range
    const exactMatch = t.match(exactPattern);
    if (exactMatch) {
      // we found the correct exact match
      if (parseInt(exactMatch[1], 10) === choice) {
        // eslint-disable-next-line prefer-destructuring
        result = exactMatch[2];
      }
    } else {
      const rangeMatch = t.match(rangePattern);
      // there was no pattern
      if (!rangeMatch) {
        return;
      }
      const startParam = rangeMatch[2];
      const endParam = rangeMatch[3];
      let start: number | undefined;
      let end: number | undefined;

      if (startParam !== 'Inf') {
        start = parseInt(startParam, 10);
      }
      if (endParam !== 'Inf') {
        end = parseInt(endParam, 10);
      }

      // starting range excludes the start value
      if (rangeMatch[1] === ']' && start !== undefined) {
        start += 1;
      }
      // ending range excludes the end value
      if (rangeMatch[4] === '[' && end !== undefined) {
        end -= 1;
      }

      // the passed in value was within the range
      if ((start === undefined || choice >= start) && (end === undefined || choice <= end)) {
        // eslint-disable-next-line prefer-destructuring
        result = rangeMatch[5];
      }
    }
  });
  return trans(result, context);
}

export function transExists(key: string): boolean {
  return translation().messages[key] !== undefined;
}

/**
 * Simple translation component
 * Use it as a mixin and directly call the methods defined below
 */
export default {
  methods: {
    trans,
    // a typical multiple choice pattern looks like:
    // '{0} no apples|{1} one apple|]1, Inf] A lot of apples'
    // Taken from : https://github.com/Digelly/vue-trans/blob/master/src/filter.js
    transchoice,
    transExists,
  },
};
